export interface Template {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  image: string;
  description: string;
  features: string[];
}

export const templates: Template[] = [
  {
    id: 1,
    title: '极简企业官网',
    category: '企业网站',
    categorySlug: 'business',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20corporate%20website%20template%20design%20with%20clean%20white%20background%20and%20warm%20accent%20colors%2C%20elegant%20typography%20layout%2C%20professional%20business%20aesthetic%2C%20soft%20natural%20lighting%2C%20high%20quality%20web%20design%20mockup&width=800&height=600&seq=tpl-business-01&orientation=landscape',
    description: '简洁大气的企业官网模板，适合各类中小型企业展示公司形象',
    features: ['响应式布局', '关于我们页面', '服务展示', '联系表单'],
  },
  {
    id: 2,
    title: '创意品牌官网',
    category: '企业网站',
    categorySlug: 'business',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20creative%20brand%20website%20template%20with%20warm%20coral%20and%20neutral%20tones%2C%20modern%20layout%20with%20large%20hero%20image%2C%20clean%20typography%2C%20professional%20design%20mockup%20on%20light%20background&width=800&height=600&seq=tpl-business-02&orientation=landscape',
    description: '充满设计感的品牌官网模板，通过独特的视觉风格展现品牌个性',
    features: ['品牌故事', '动态效果', '作品集展示', '社交媒体集成'],
  },
  {
    id: 3,
    title: '在线商城模板',
    category: '电商网站',
    categorySlug: 'ecommerce',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20ecommerce%20website%20template%20design%20with%20product%20grid%20layout%2C%20warm%20neutral%20color%20scheme%2C%20minimalist%20shopping%20interface%2C%20soft%20lighting%2C%20professional%20online%20store%20mockup&width=800&height=600&seq=tpl-ecom-01&orientation=landscape',
    description: '功能完善的电商网站模板，支持商品展示、购物车和在线支付功能',
    features: ['商品分类', '购物车', '在线支付', '订单管理'],
  },
  {
    id: 4,
    title: '时尚品牌店铺',
    category: '电商网站',
    categorySlug: 'ecommerce',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20fashion%20boutique%20website%20template%20with%20warm%20earthy%20tones%2C%20elegant%20product%20display%2C%20sophisticated%20layout%2C%20soft%20natural%20textures%2C%20high%20end%20online%20store%20design%20mockup&width=800&height=600&seq=tpl-ecom-02&orientation=landscape',
    description: '高端时尚品牌电商模板，精致的商品展示效果提升转化率',
    features: ['大图展示', '品牌故事', '限时促销', '会员系统'],
  },
  {
    id: 5,
    title: '个人博客模板',
    category: '博客网站',
    categorySlug: 'blog',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20personal%20blog%20website%20template%20with%20warm%20cream%20background%2C%20clean%20article%20layout%2C%20elegant%20serif%20typography%2C%20soft%20ambient%20lighting%2C%20cozy%20reading%20experience%20design%20mockup&width=800&height=600&seq=tpl-blog-01&orientation=landscape',
    description: '清新简约的博客模板，为内容创作者打造舒适的写作和阅读空间',
    features: ['文章分类', '标签系统', '评论功能', '订阅邮件'],
  },
  {
    id: 6,
    title: '摄影作品集',
    category: '博客网站',
    categorySlug: 'blog',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20photography%20portfolio%20website%20template%20with%20warm%20minimal%20design%2C%20full%20width%20image%20gallery%20layout%2C%20soft%20neutral%20tones%2C%20creative%20professional%20mockup%20on%20light%20surface&width=800&height=600&seq=tpl-blog-02&orientation=landscape',
    description: '专为视觉创作者打造的瀑布流展示模板，让作品成为焦点',
    features: ['瀑布流布局', '全屏浏览', 'EXIF信息', '水印保护'],
  },
  {
    id: 7,
    title: '餐饮美食网站',
    category: '餐饮网站',
    categorySlug: 'restaurant',
    image: 'https://readdy.ai/api/search-image?query=Warm%20inviting%20restaurant%20website%20template%20design%20with%20earthy%20natural%20tones%2C%20menu%20display%20layout%2C%20cozy%20dining%20atmosphere%2C%20soft%20warm%20lighting%2C%20elegant%20food%20photography%20mockup&width=800&height=600&seq=tpl-rest-01&orientation=landscape',
    description: '温暖诱人的餐饮网站模板，完美展示菜单和就餐环境',
    features: ['在线菜单', '预约订座', '位置导航', '顾客评价'],
  },
  {
    id: 8,
    title: '在线教育平台',
    category: '教育培训',
    categorySlug: 'education',
    image: 'https://readdy.ai/api/search-image?query=Modern%20online%20education%20platform%20website%20template%20with%20warm%20inviting%20design%2C%20course%20grid%20layout%2C%20clean%20organized%20interface%2C%20soft%20natural%20light%2C%20professional%20learning%20management%20mockup&width=800&height=600&seq=tpl-edu-01&orientation=landscape',
    description: '结构清晰的在线教育模板，支持课程展示和学员管理',
    features: ['课程列表', '视频播放', '学习进度', '证书发放'],
  },
  {
    id: 9,
    title: '健身房官网',
    category: '教育培训',
    categorySlug: 'education',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20fitness%20gym%20website%20template%20with%20warm%20energetic%20design%2C%20class%20schedule%20layout%2C%20motivational%20aesthetic%2C%20soft%20gym%20lighting%2C%20professional%20fitness%20center%20mockup&width=800&height=600&seq=tpl-edu-02&orientation=landscape',
    description: '充满活力的健身网站模板，展示课程表和教练团队',
    features: ['课程预约', '教练介绍', '会员管理', '营养咨询'],
  },
  {
    id: 10,
    title: '律师事务所官网',
    category: '企业网站',
    categorySlug: 'business',
    image: 'https://readdy.ai/api/search-image?query=Professional%20law%20firm%20website%20template%20with%20warm%20trustworthy%20design%2C%20clean%20structured%20layout%2C%20elegant%20typography%2C%20soft%20office%20lighting%2C%20sophisticated%20legal%20services%20mockup&width=800&height=600&seq=tpl-business-03&orientation=landscape',
    description: '专业稳重的律所官网模板，传递信任感和专业形象',
    features: ['团队介绍', '业务领域', '案例展示', '在线咨询'],
  },
  {
    id: 11,
    title: '医疗诊所网站',
    category: '医疗健康',
    categorySlug: 'healthcare',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20medical%20clinic%20website%20template%20with%20warm%20healing%20atmosphere%2C%20appointment%20booking%20layout%2C%20soft%20natural%20lighting%2C%20trustworthy%20healthcare%20design%20mockup%20on%20light%20surface&width=800&height=600&seq=tpl-health-01&orientation=landscape',
    description: '干净整洁的医疗诊所模板，方便患者了解服务和预约就诊',
    features: ['在线预约', '医生介绍', '科室导航', '健康资讯'],
  },
  {
    id: 12,
    title: '美容Spa官网',
    category: '医疗健康',
    categorySlug: 'healthcare',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20beauty%20spa%20website%20template%20with%20warm%20soothing%20tones%2C%20elegant%20service%20display%2C%20relaxing%20atmosphere%2C%20soft%20candle%20lighting%2C%20premium%20wellness%20center%20mockup&width=800&height=600&seq=tpl-health-02&orientation=landscape',
    description: '优雅舒适的美容Spa模板，营造放松愉悦的浏览体验',
    features: ['服务介绍', '在线预约', '优惠活动', '会员卡'],
  },
];

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '企业网站', slug: 'business' },
  { name: '电商网站', slug: 'ecommerce' },
  { name: '博客网站', slug: 'blog' },
  { name: '餐饮网站', slug: 'restaurant' },
  { name: '教育培训', slug: 'education' },
  { name: '医疗健康', slug: 'healthcare' },
];